import { render, staticRenderFns } from "./MealDetailTable.vue?vue&type=template&id=789efe07&"
import script from "./MealDetailTable.vue?vue&type=script&lang=js&"
export * from "./MealDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./MealDetailTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports